// Публичная страница /support — большой FAQ + форма создания.
// Доступна гостям и залогиненным.
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SupportShell from "../components/support/SupportShell";
import CabinetChrome from "../components/cabinet/CabinetChrome";
import { useAuth } from "../context/AuthContext";
import FaqList from "../components/support/FaqList";
import FaqArticle from "../components/support/FaqArticle";
import TicketCreateForm from "../components/support/TicketCreateForm";
import { ChatBubbleLeftRightIcon } from "../components/icons/ChatBubbleLeftRightIcon";
import { BellIcon } from "../components/icons/BellIcon";
import usePageTitle from "../hooks/usePageTitle";
import "../styles/support.css";

export default function SupportPage() {
  usePageTitle("Связаться с разрабом");
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // mode: "menu" | "create" | "article" | "done"
  const [mode, setMode] = useState("menu");
  const [articleId, setArticleId] = useState(null);
  const [createdId, setCreatedId] = useState(null);

  return (
    <CabinetChrome>
    <SupportShell>
      <div className="sup-page">
        <div className="sup-page__hero">
          <h1>Свяжись с разработчиком Рублокса</h1>
          <p>
            Нашёл баг, есть вопрос про подписку или просто застрял —
            напиши прямо МИНу. Я отвечу на каждое обращение.
          </p>
          <div className="sup-page__hero-sla">
            <BellIcon size={14} color="#fff" />
            Отвечаем в течение 48 часов
          </div>
        </div>

        {mode === "menu" && (
          <>
            <div className="sup-page__row">
              <button type="button" className="sup-btn-primary"
                      onClick={() => setMode("create")}>
                <ChatBubbleLeftRightIcon size={16} color="#fff" />
                Создать обращение
              </button>
              {isAuthenticated && (
                <button type="button" className="sup-btn-ghost"
                        onClick={() => navigate("/support/my")}>
                  Мои обращения
                </button>
              )}
            </div>

            <h2>Частые вопросы</h2>
            <FaqList onPickArticle={(a) => {
              setArticleId(a.id);
              setMode("article");
            }} />
          </>
        )}

        {mode === "create" && (
          <>
            <button type="button" className="sup-btn-ghost"
                    onClick={() => setMode("menu")}
                    style={{ marginBottom: 12 }}>
              ‹ К FAQ
            </button>
            <h2 style={{ marginTop: 0 }}>Новое обращение</h2>
            <TicketCreateForm
              onCreated={(id) => {
                setCreatedId(id);
                setMode("done");
              }}
              onPickFaqArticle={(a) => {
                setArticleId(a.id);
                setMode("article");
              }}
            />
          </>
        )}

        {mode === "article" && (
          <FaqArticle
            id={articleId}
            onBack={() => setMode("menu")}
            onCreateTicket={() => setMode("create")}
          />
        )}

        {mode === "done" && (
          <div>
            <div className="sup-msg-ok" style={{ marginBottom: 14 }}>
              Обращение №{createdId} отправлено. МИН ответит в течение 48 часов.
            </div>
            {isAuthenticated ? (
              <div className="sup-page__row">
                <button type="button" className="sup-btn-primary"
                        onClick={() => navigate(`/support/ticket/${createdId}`)}>
                  Открыть переписку
                </button>
                <button type="button" className="sup-btn-ghost"
                        onClick={() => setMode("menu")}>
                  Назад к FAQ
                </button>
              </div>
            ) : (
              <div className="sup-msg-info">
                Ответ придёт на указанный email. Если хочешь видеть переписку
                на сайте — войди в аккаунт.
              </div>
            )}
          </div>
        )}
      </div>
    </SupportShell>
    </CabinetChrome>
  );
}
